import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCiAesNOnxl9TPKNGigTqmexVg6Yr_Far0",
  authDomain: "medigrow-project.firebaseapp.com",
  projectId: "medigrow-project",
  storageBucket: "medigrow-project.firebasestorage.app",
  messagingSenderId: "408003638803",
  appId: "1:408003638803:web:ae5507afda6ad6479d31e6",
  measurementId: "G-XF0Z1SJJX5"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app)
export const storage = getStorage(app)
export const auth = getAuth(app)

